/* eslint-disable import/group-exports */

export const BLUE_50 = '#E5EEF6';
export const BLUE_100 = '#CCDDED';
export const BLUE_200 = '#99BBDB';
export const BLUE_300 = '#3D7DBB';
export const BLUE_400 = '#1462AD';
export const BLUE_500 = '#0054A6'; // primary
export const BLUE_600 = '#003D79';

export const NEUTRAL_50 = '#FAFAFA';
export const NEUTRAL_100 = '#F5F5F5';
export const NEUTRAL_200 = '#E6E9EB';
export const NEUTRAL_300 = '#CCD3D6';
export const NEUTRAL_400 = '#99A6AD';
export const NEUTRAL_500 = '#677A85';
export const NEUTRAL_600 = '#486170';
export const NEUTRAL_700 = '#344D5C';
export const NEUTRAL_800 = '#1C3A4B';
export const NEUTRAL_900 = '#012133';

export const LIGHT_BLUE_50 = '#EAF4FE';
export const LIGHT_BLUE_100 = '#D6EAFE';
export const LIGHT_BLUE_200 = '#ADD5FD';
export const LIGHT_BLUE_300 = '#84C0FB';
export const LIGHT_BLUE_400 = '#5BABFA';
export const LIGHT_BLUE_500 = '#3296F9';

export const LEGACY_500 = '#2a3b4c';
export const LEGACY_600 = '#263545';
export const LEGACY_800 = '#1d2c3a';

export const GREEN_50 = '#E5F6ED';
export const GREEN_100 = '#CCEDDB';
export const GREEN_200 = '#99DCB7';
export const GREEN_300 = '#66CA94';
export const GREEN_400 = '#33B970';
export const GREEN_500 = '#00A74C';

export const RED_50 = '#F9E5E8';
export const RED_100 = '#F4CCD1';
export const RED_200 = '#E999A3';
export const RED_300 = '#DD6674';
export const RED_400 = '#D23346';
export const RED_500 = '#C70018';

export const YELLOW_50 = '#FFF7E8';
export const YELLOW_100 = '#FFF3DC';
export const YELLOW_200 = '#FEDFA2';
export const YELLOW_300 = '#FDCF74';
export const YELLOW_400 = '#FDBF45';
export const YELLOW_500 = '#FCAF17';

export const BRAND = BLUE_500;
export const BLACK = '#000';
export const WHITE = '#FFF';
export const TRANSPARENT = 'transparent';
export const CURRENT = 'currentColor';
export const NONE = 'none';
export const INHERIT = 'inherit';
export const PRIMARY = NEUTRAL_900;
export const SECONDARY = NEUTRAL_800;

export const BLUE = {
  50: BLUE_50,
  100: BLUE_100,
  200: BLUE_200,
  300: BLUE_300,
  400: BLUE_400,
  500: BLUE_500,
  600: BLUE_600,
};

export const NEUTRAL = {
  50: NEUTRAL_50,
  100: NEUTRAL_100,
  200: NEUTRAL_200,
  300: NEUTRAL_300,
  400: NEUTRAL_400,
  500: NEUTRAL_500,
  600: NEUTRAL_600,
  700: NEUTRAL_700,
  800: NEUTRAL_800,
  900: NEUTRAL_900,
};

export const LIGHT_BLUE = {
  50: LIGHT_BLUE_50,
  100: LIGHT_BLUE_100,
  200: LIGHT_BLUE_200,
  300: LIGHT_BLUE_300,
  400: LIGHT_BLUE_400,
  500: LIGHT_BLUE_500,
};

export const GREEN = {
  50: GREEN_50,
  100: GREEN_100,
  200: GREEN_200,
  300: GREEN_300,
  400: GREEN_400,
  500: GREEN_500,
};

export const RED = {
  50: RED_50,
  100: RED_100,
  200: RED_200,
  300: RED_300,
  400: RED_400,
  500: RED_500,
};

export const YELLOW = {
  50: YELLOW_50,
  100: YELLOW_100,
  200: YELLOW_200,
  300: YELLOW_300,
  400: YELLOW_400,
  500: YELLOW_500,
};

export const LEGACY = {
  500: LEGACY_500,
  600: LEGACY_600,
  800: LEGACY_800,
};
